import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useSite } from "@/lib/SiteContext";

export default function PageView() {
  const { slug } = useParams();
  const { brand } = useSite();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    api
      .get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-cream font-sans text-ink antialiased">
      <header className="border-b border-line/70 bg-cream/90 backdrop-blur-xl">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-6">
          <Link to="/" className="flex items-center gap-2" data-testid="page-brand-link">
            <Heart size={18} className="fill-rose text-rose" />
            <span className="font-serif text-xl font-semibold">{brand.name}</span>
          </Link>
          <Link to="/" className="text-sm font-medium text-[#5C5C5C] transition-colors hover:text-rose" data-testid="page-back-link">
            ← Back to website
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-16 md:py-24">
        {!page && !notFound && (
          <div className="flex justify-center py-20">
            <Loader2 size={26} className="animate-spin text-rose" />
          </div>
        )}
        {notFound && (
          <div data-testid="page-not-found" className="py-20 text-center">
            <h1 className="font-serif text-4xl font-medium">Page not found</h1>
            <p className="mt-3 text-sm text-[#5C5C5C]">This page may have been unpublished or removed.</p>
          </div>
        )}
        {page && (
          <article data-testid="page-content">
            <h1 className="font-serif text-4xl font-medium tracking-tight md:text-5xl">{page.title}</h1>
            <div className="mt-8 flex flex-col gap-5">
              {String(page.content || "").split(/\n\n+/).filter(Boolean).map((para, i) => (
                <p key={i} className="whitespace-pre-line text-sm leading-relaxed text-[#5C5C5C] md:text-base">
                  {para}
                </p>
              ))}
            </div>
          </article>
        )}
      </main>
    </div>
  );
}
